import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiSearch } from 'react-icons/fi';
import './SystemState.css';

// Shown for routes that don't lead anywhere real (unfinished stubs, mistyped URLs).
// Distinct from ErrorBoundary: this is "nothing here", not "something crashed".
export default function NotFound() {
  const { t } = useTranslation('systemState');
  const navigate = useNavigate();

  return (
    <div className="system-state">
      <div className="system-state-icon-badge system-state-icon-badge--yellow">
        <FiSearch size={24} />
      </div>
      <h2 className="system-state-title">{t('notFoundTitle')}</h2>
      <p className="system-state-desc">{t('notFoundDesc')}</p>
      <div className="system-state-actions">
        <button className="system-state-btn-primary" onClick={() => navigate('/')}>
          {t('goToFrontpage')}
        </button>
      </div>
    </div>
  );
}
